
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  EmailAddressValidityResponse,
} from '../models';
import {
    EmailAddressValidityResponseFromJSON,
    EmailAddressValidityResponseToJSON,
} from '../models';

export interface GetEmailAddressValidityRequest {
    email: string;
}

/**
 * 
 */
export class UmbrellaEmailAddressValidityApi extends runtime.BaseAPI {

    /**
     * Ask whether an email address can be used for signing up to Malt
          */
    async getEmailAddressValidityRaw(requestParameters: GetEmailAddressValidityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<EmailAddressValidityResponse>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getEmailAddressValidity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<EmailAddressValidityResponse>({
            path: `/compliance/api/email-address-validity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=EmailAddressValidityResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Ask whether an email address can be used for signing up to Malt
          */
    async getEmailAddressValidity(requestParameters: GetEmailAddressValidityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<EmailAddressValidityResponse> {
        const response = await this.getEmailAddressValidityRaw(requestParameters, initOverrides);
        return response._data;
    }

}
